import { createSystem, defaultConfig } from '@chakra-ui/react';

import { raspberryBaseTheme } from './base';

const cssScope = ':where(.nocowanie-root, [data-part="positioner"])';

/**
 * Additional styles for Web components
 */
const raspberryWcTheme = createSystem(defaultConfig, raspberryBaseTheme, {
    preflight: {
        scope: cssScope,
    },
    disableLayers: true,

    globalCss: {
        [cssScope]: {
            fontFamily: 'inherit',
        },
        [`${cssScope} a[href]:not([class])`]: {
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textDecorationColor: 'currentColor/20',
        },
    },
});

export default raspberryWcTheme;
